module.exports = __webpack_public_path__ + "fonts/Inter-Light.5baca21.woff2";